import React from "react"
import BlkMeaAct from "../../common/blockMeaAct/blockMeaAct"
import Divider from "../../common/divider"
import BlockInfo from "../../experience/blockInfo"
import BlkRestaurant from "../../common/blockRestaurant/blockRestaurant"
import BlockPostGridGeneric from "../blockPostGridGeneric/blockPostGridGeneric"
import BlockTextFullMediaGeneric from "../blockTextFullMediaGeneric/blockTextFullMediaGeneric"
import BlockTextGeneric from "../blockTextGeneric/blockTextGeneric"
import BlockTextMediaGeneric from "../blockTextMediaGeneric/blockTextMediaGeneric"
import BlockTextMoreGeneric from "../blockTextMoreGeneric/blockTextMoreGeneric"
import Blkmarquee from "../../common/marquee/marquee";
import BlkThreeCol from "../../common/blockThreeCol/blockThreeCol";
import BlkADecouvrir from "../../common/blockADecouvrir/blockADecouvrir"
import BlkTwoCol from "../../common/blockTwoCol/blockTwoCol";
import BlkFourCol from "../../common/blockFourCol/blockFourCol";
import BlockHighlight from "../../common/blockHighlight/blockHighlight";
import BlockInfoDetails from "../../experience/blockInfoDetails"
import BlockMedias from "../../experience/blockMedias"
import PushExperience from "../../experience/pushExperience"
import BlockInclusive from "../../experience/blockInclusive"
const GenericComponents = ( props ) => {
  const isSSR = typeof window === "undefined"

  const components = props.components;

  const blockInfoPratique  = components.filter((component) => component.internal.type === "paragraph__information_pratique")
  const blkInfoDetails = components.filter((component) => component.internal.type === "paragraph__details")
  const IllusExp = React.lazy(() =>
    import("../../common/blockIllus/blockIllus")
  )

  const elements = components.map(function (component) {
    const type = component.internal.type
    switch (type) {
      case "paragraph__block_media_separator":
        // unique id for each separator for locomotive scroll animation
        const separatorID = component.drupal_internal__id
        return (
          <IllusExp content={component} blockID={"illusSep" + separatorID} />
        )
      case "paragraph__information_pratique":
        return <BlockInfo info={component} />
      case "paragraph__block_medias_text":
        return <BlkRestaurant content={component} />
      case "paragraph__block_featured_activity":
        return <BlkMeaAct content={component} />
      case "paragraph__block_grid":
        return <BlockTextMoreGeneric content={component} />
      case "paragraph__block_media_text":
        return <BlockTextMediaGeneric
        collectEx={props.collectEx}
        info={blkInfoDetails[0]}
        content={component}
        pageTitle={props.pageTitle  }
        featuredImage={props.featuredImage}
        id={props.drupalId}
        fixedPrice={blockInfoPratique[0]?.fixed_experience_price}
        price={blockInfoPratique[0]?.price}
        priceChild={blockInfoPratique[0]?.price_child}
        intro={props.intro?.introduction_title}
        />
      case "paragraph__whats_included":
        return <BlockInclusive info={component} />
      case "paragraph__block_text":
        return <BlockTextGeneric content={component} />
      case "paragraph__block_two_columns_layout":
        return <BlkTwoCol content={component}/>
      case "paragraph__block_three_columns_layout":
        return <BlkThreeCol content={component}/>
      case "paragraph__block_four_columns_layout":
        return <BlkFourCol content={component}/>
      case "paragraph__details":
        return (
          <>
            <BlockInfoDetails
              pageTitle={props.pageTitle}
              featuredImage={props.featuredImage}
              id={props.drupalId}
              price={blockInfoPratique[0]?.price}
              priceChild={blockInfoPratique[0]?.price_child}
              intro={props.intro.introduction_title}
              info={component}
            />
            {(props.collectEx === true && props.experiences) && (
              <PushExperience experiences={props.experiences} />
            )}
          </>
        )
      case "paragraph__block_text_full_media":
        return (
          <>
            <Divider />
            <BlockTextFullMediaGeneric content={component} />
          </>
        )
      case "paragraph__block_post_grid":
        return (
          <>
            <BlockPostGridGeneric content={component} />
          </>
        )
      case "paragraph__marquee":
        return <Blkmarquee content={component}/>
      case "paragraph__block_read_more":
        return <BlkADecouvrir content={component}/>
      case "paragraph__block_highlights_2":
        return <BlockHighlight content={component}/>
      default:
        return <></>
    }
  })
  return (
    <>
      {!isSSR && (
        <React.Suspense fallback="loading.... ">{elements}</React.Suspense>
      )}
    </>
  )
}

export default GenericComponents
